import queryString from "query-string";

import { MASTER_RULE_BOOK, RULE_BOOK } from "constants/actionTypes";

import { URLCreatorProps } from "actions/types";
import {
  offlineActionCreator,
  offlineSubActionCreator,
  passthroughSerializer,
  urlCheckAndAddIdAndAction,
} from "./lib";

const ruleBookUrlCreator = ({
  changesSince,
  deploymentId,
  saleyardName,
  id,
  action,
}: URLCreatorProps = {}) =>
  queryString.stringifyUrl({
    url: urlCheckAndAddIdAndAction("/v2/rule-books/", id, action),
    query: {
      changesSince,
      deployment_id: deploymentId,
      saleyard_name: saleyardName || undefined,
    },
  });

export const RuleBookAction = offlineActionCreator(
  RULE_BOOK,
  passthroughSerializer,
  ruleBookUrlCreator,
  false,
);

RuleBookAction.unsubscribeFromMasterRuleBook = offlineSubActionCreator(
  RULE_BOOK.UNSUBSCRIBE_FROM_MASTER_RULE_BOOK,
  ({ id, masterRuleBookId }) =>
    `/v2/rule-books/${id}/unsubscribe/?master_rule_book_id=${masterRuleBookId}`,
);

RuleBookAction.synchronizeWithMasterRuleBook = offlineSubActionCreator(
  RULE_BOOK.SYNCHRONIZE_WITH_MASTER_RULE_BOOK,
  ({ id, masterRuleBookId }) =>
    `/v2/rule-books/${id}/synchronize/?master_rule_book_id=${masterRuleBookId}`,
);

RuleBookAction.copy = (sourceRuleBookId, destinationRuleBookId, options) => ({
  type: RULE_BOOK.COPY.ACTION,
  destinationRuleBookId,
  sourceRuleBookId,
  options,
});

const masterRuleBookUrlCreator = ({
  changesSince,
  id,
  action,
}: URLCreatorProps = {}) =>
  queryString.stringifyUrl({
    url: urlCheckAndAddIdAndAction("/v2/master-rule-books/", id, action),
    query: { changesSince },
  });

export const MasterRuleBookAction = offlineActionCreator(
  MASTER_RULE_BOOK,
  passthroughSerializer,
  masterRuleBookUrlCreator,
  false,
);

MasterRuleBookAction.synchronizeAll = offlineSubActionCreator(
  MASTER_RULE_BOOK.SYNCHRONIZE_ALL,
  ({ id }) => `/v2/master-rule-books/${id}/synchronize/`,
);

MasterRuleBookAction.copy = (
  sourceMasterRuleBookId: string,
  destinationMasterRuleBookId: string,
  // TODO: Define CopyOptions interface based on API requirements
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options: any,
) => ({
  type: MASTER_RULE_BOOK.COPY.ACTION,
  destinationMasterRuleBookId,
  sourceMasterRuleBookId,
  options,
});
